import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import {initialUsersState, IPreviousLeaderboard, IUsersResponse, IUserState, PointsHistoryResponse} from "./Helper";
import {getPointsHistory, getPreviousLeaderboard, getUsers} from "./ActionCreators";

const initialValue: IUserState = {
    loading: false,
    items: initialUsersState,
    previousLeaderboard: [],
    buyGiftCouponLoading: false,
    pointsHistoryLoading: false,
    pointsHistory: {
        count: 0,
        points: []
    }
}

const userSlice = createSlice({
    name: SliceNames.USER,
    initialState: initialValue,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(
            getUsers.pending, (state) => {
                state.loading = true
            })
            .addCase(
                getUsers.fulfilled, (state, action: PayloadAction<IUsersResponse>) => {
                    state.loading = false
                    state.items = action.payload
                })
            .addCase(
                getUsers.rejected, (state) => {
                    state.items = initialUsersState
                    state.loading = false
                })
            .addCase(
                getPreviousLeaderboard.fulfilled, (state, action: PayloadAction<IPreviousLeaderboard[]>) => {
                    state.previousLeaderboard = action.payload
                })
            .addCase(
                getPreviousLeaderboard.rejected, (state) => {
                    state.previousLeaderboard = []
                })
            .addCase(
                getPointsHistory.pending, (state) => {
                    state.pointsHistoryLoading = true
                })
            .addCase(
                getPointsHistory.fulfilled, (state, action: PayloadAction<PointsHistoryResponse>) => {
                    state.pointsHistoryLoading = false
                    state.pointsHistory = action.payload
                })
            .addCase(
                getPointsHistory.rejected, (state) => {
                    state.pointsHistoryLoading = false
                })
    }
})

export default userSlice.reducer
